import { Slide, Backdrop, Portal, Box } from '@mui/material';
import { ReactNode, useCallback, MouseEvent } from 'react';

const ANIMATION_TIMEOUT = 300;

type ModalFullScreenDrawerProps = {
  open: boolean;
  children: ReactNode;
  onClose?(): void;
  onExited?(): void;
  bgcolor?: string; // sx.bgcolor prop
};

export const ModalFullScreenDrawer = (props: ModalFullScreenDrawerProps) => {
  const { open = false, children, onClose, onExited, bgcolor = 'background.paper' } = props;

  const onClick = useCallback(
    (e: MouseEvent) => {
      if (onClose !== undefined && e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Portal>
      <Backdrop open={open} onClick={onClick} timeout={ANIMATION_TIMEOUT}>
        <Slide direction="up" appear in={open} onExited={onExited} timeout={ANIMATION_TIMEOUT} unmountOnExit>
          <Box
            sx={{
              width: '100%',
              height: '100dvh',
              display: 'flex',
              justifyContent: 'start',
              flexDirection: 'column',
              alignItems: 'center',
              overflow: 'hidden',
              bgcolor,
            }}>
            {children}
          </Box>
        </Slide>
      </Backdrop>
    </Portal>
  );
};
